import React from 'react'
import PropTypes from 'prop-types'
import LoadFinishedGeneral from '../../LoadFinishedGeneral'

import styles from './MainApp.organisms.Tags.TagAssociationFinished.module.scss'
import i18n from 'i18n'

export const TagAssociationFinished = ({ boldButtonFunc, buttonLink = '/admin/config_tags' }) => {
  return (
    <LoadFinishedGeneral
      title={i18n.t("tag.association")}
      boldButtonLabel={i18n.t("associate.another.tags")}
      boldButtonFunc={boldButtonFunc}
      buttonLabel={i18n.t("see.template.list")}
      buttonLink={buttonLink}
    >
      <div className={styles["tag-association--finished-container"]}>
        {i18n.t("tags.associate.successfully")}
      </div>
    </LoadFinishedGeneral>
  )
}

export default TagAssociationFinished
